<template>
  <div>
    <clinicList
      :canEdit="true"
      editRoute="AdminClinicEdit"
      :canCreate="true"
      createRoute="AdminClinicCreate"
      :canViewDetail="true"
      viewRoute="AdminClinicDetail"
      :canViewClinicTreatmentHistory="true"
      clinicTreatmentHistoryRoute="AdminClinicTreatmentHistory"
    />
  </div>
</template>

<script>
import clinicList from '../../components/clinics/clinicList.vue';

export default {
  components: {
    clinicList,
  },
  data: () => ({}),
};
</script>
